export default {
  id: 115,
  title: 'Target #115 - Droplet',
  url: 'https://cssbattle.dev/play/115',
  colors: ['#C36271', '#F2E09F'],
  solution:
    '<a a><a b><style>a{position:fixed}[a]{top:0;left:20;width:360;height:150;background:#f2e09f;border-radius:100px 0;box-shadow:150px 0 #c36271,-150px 0 #f2e09f,0 150px #c36271,150px 150px #c36271,-150px 150px #f2e09f}[b]{top:100;left:150;width:100;height:100;background:linear-gradient(to bottom,#c36271 50px,#f2e09f 50px);border-radius:9in}</style>',
}
